/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homehelpwithtechnicalissues4Inputs */



/**
* | output |
* | --- |
* | "If you are experiencing technical issues, feel free to contact us. We are happy to assist you personally as well. Please reach out to the participant support..." |
*
* @param {Homehelpwithtechnicalissues4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homehelpwithtechnicalissues4 = /** @type {((inputs?: Homehelpwithtechnicalissues4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homehelpwithtechnicalissues4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("If you are experiencing technical issues, feel free to contact us. We are happy to assist you personally as well. Please reach out to the participant support of the respective project or send an email to <a href='mailto:support@dmun.de' class='link underline'>support@dmun.de</a>.")
	return /** @type {LocalizedString} */ ("Wir helfen dir gern persönlich weiter. Wende dich an deine Teilnehmendenbetreuung oder an <a href='mailto:support@dmun.de' class='link underline'>support@dmun.de</a>.")
});
export { homehelpwithtechnicalissues4 as "homeHelpWithTechnicalIssues" }